/*
 * VANA – Mobile-Karten-Slider auf Kollektionsseiten
 * Ausgelagert am 12.10.2026 aus snippets/product-grid-item-variant.liquid.
 * Vorher lag dieses Skript in JEDER Produktkarte (48x pro Seite, ~154 KB) und
 * hat bei jeder Karte die ganze Seite neu durchsucht. Jetzt: einmal pro Seite.
 * Verhalten unverändert: Wischen pro Karte, Punkte-Anzeige, Klick-Schutz beim Wischen.
 * 22.10.2026: Bild 2 und 3 jeder Karte liegen als <template data-vana-defer> vor und werden erst
 * eingesetzt, wenn die Karte nach dem Seitenaufbau sichtbar wird oder jemand wischt.
 */
(function () {
  if (window.__vanaCollectionCardSliderBooted) return;
  window.__vanaCollectionCardSliderBooted = true;

  function revealDeferred(slider) {
    slider.querySelectorAll('template[data-vana-defer]').forEach(function (t) {
      t.replaceWith(t.content.cloneNode(true));
    });
  }

  // Erst nach window.load beobachten, damit Bild 2/3 nicht mit dem ersten Seitenaufbau konkurrieren
  var pageLoaded = document.readyState === 'complete';
  var pending = [];
  var io = null;
  function getObserver() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        revealDeferred(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    return io;
  }
  function observeDeferred(slider) {
    if (!slider.querySelector('template[data-vana-defer]')) return;
    if (!pageLoaded) { pending.push(slider); return; }
    var obs = getObserver();
    if (obs) obs.observe(slider); else revealDeferred(slider);
  }
  if (!pageLoaded) {
    window.addEventListener('load', function () {
      pageLoaded = true;
      pending.forEach(observeDeferred);
      pending = [];
    });
  }

  function initSlider(slider) {
    if (slider.dataset.vanaInit === '1') return;
    slider.dataset.vanaInit = '1';

    slider.addEventListener('pointerdown', function () { revealDeferred(slider); }, { passive: true, once: true });
    observeDeferred(slider);

    var sliderWrap = slider.closest('[data-vana-mobile-card-slider-wrap]') || slider.parentElement || slider;
    var dotsWrap = sliderWrap.querySelector('[data-vana-mobile-dots]');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('[data-vana-mobile-dot]') : [];

    var startX = 0;
    var startY = 0;
    var moved = false;
    var threshold = 8;

    slider.addEventListener('pointerdown', function (e) {
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });

    slider.addEventListener('pointermove', function (e) {
      var dx = Math.abs(e.clientX - startX);
      var dy = Math.abs(e.clientY - startY);
      if (dx > threshold && dx > dy) moved = true;
    }, { passive: true });

    var link = slider.closest('a');
    if (link) {
      link.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    function setActiveDot(index) {
      if (!dots.length) return;
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      if (dots[index]) dots[index].classList.add('is-active');
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var w = slider.clientWidth || 1;
        var idx = Math.round(slider.scrollLeft / w);
        if (idx < 0) idx = 0;
        if (idx > dots.length - 1) idx = dots.length - 1;
        setActiveDot(idx);
        ticking = false;
      });
    }

    slider.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll(root) {
    root = root || document;
    if (root.matches && root.matches('[data-vana-mobile-card-slider]')) initSlider(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-vana-mobile-card-slider]').forEach(initSlider);
  }

  function boot() {
    initAll(document);

    // Nachgeladene Karten (Filter, Sortierung, "mehr laden") – nur den Hauptinhalt beobachten,
    // nicht die ganze Seite (Klaviyo, Clarity usw. verändern sonst ständig das DOM).
    var target = document.getElementById('MainContent') || document.body;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) initAll(added[j]);
        }
      }
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
